export const API_URL = process.env.REACT_APP_MODE === 'Live' ? process.env.REACT_APP_DEV_URL : process.env.REACT_APP_LIVE_URL
export const MOTHER_API_URL = process.env.REACT_APP_MOTHER_URL
export const HOTEL_CODE = process.env.REACT_APP_HOTEL_CODE
export const HOTEL_NAME = process.env.REACT_APP_HOTEL_NAME
export const HOTEL_ADDRESS = process.env.REACT_APP_HOTEL_ADDRESS
export const HOTEL_CAPTION = process.env.REACT_APP_HOTEL_CAPTION
export const HOTEL_LATE_CHECK_OUT_PER_HOUR = process.env.REACT_APP_LATE_CHECK_OUT_PER_HOUR
export const HOTEL_LATE_CHECK_OUT_TIME = process.env.REACT_APP_LATE_CHECK_OUT_TIME

